<template>
  <div class="row w-100 m-0 grayish p-2 row-details">
    <div class="col-md-12 bg-white rounded py-4">
      <template>
        <div
          class="tag-badge-custom d-flex align-items-center pr-2 pl-1"
        >
          <span class="fa-stack fa-xs">
            <em
              class="far fa-circle fa-stack-2x double text-white"
            />
            <em class="fas fa-circle fa-stack-2x green" />
            <em class="fas fa-file-user fa-stack-1x fa-inverse" />
          </span>
          <span class="py-1 pl-1 font-weight-bold mb-0">
            Documentos de Uso e Inventario de Equipo
          </span>
        </div>

         <div class="d-flex align-items-center pr-2 pl-2 mt-3">
            <strong class="mb-1 document-label">
              Nombre de documento:
            </strong>                
          </div>
       
        <div
          v-for="document in documents"
          :key="document.peiId"
          class="row mx-0 mt-4 px-2"
        >
          <div class="col-12">
            <div class="row">
              <div class="col-md-10 pl-0 d-flex flex-column">               
                <span class="document-description">
                  Garantia Uso e Inventario - {{ document.peiIdFormatted }}
                </span>
              </div>
             
              <div
                class="col-2 col-md-2 d-flex flex-column mt-3 mt-md-0"
              >
                <action-button
                  type="submit"
                  text="Ver Documento"
                  i="fa fa-file-search pl-2"
                  variant="outline-success"
                  class="px-1 mr-2"
                  @click="()=> downloadDocumentHandler(document.peiId)"
                />
              </div>
            </div>
          </div>
        </div>
        <pagination      
          v-if="pagination.totalItemCount > pagination.perPage"
          :data="pagination"      
          @pagination-go-page="onPageChanged"
        />
        <CustomResultNotFound
          v-if="pagination.totalItemCount == 0"
          class="mt-4 row pt-3"
          text="No se han encontrado documentos."
        />
      </template>
    </div>
  </div>
</template>
<script>

import Pagination from 'pagination';
import ActionButton from 'ActionButton';
import CustomResultNotFound from "custom-result-not-found";
import reportService from '@/services/report';

export default {
    name: 'GuaranteeDocuments',
    components: {
      Pagination,
      ActionButton,
      CustomResultNotFound
    },
    props: {
      peiAtServiceId: {
        type: Number,
        default: 0,
        required: true,
      },
      studentSieId: {
        type: String,
        default: '',
        required: true,
      },
    },
    data() {
      return{
        documents: [],
        pagination: {
          perPage: 5,
          currentPage: 1,
          totalItemCount: 0,
          pageCount: 0,
          count: 0,
        }       
      }
    },
    async mounted(){    
      await this.loadDocuments(1);
    },
    methods:{
      async loadDocuments(page){
        this.$ApiGet(`/api/atservice/searchguaranteedocuments?peiAtServiceId=${this.peiAtServiceId}&page=${page}&pageSize=${this.pagination.perPage}`)
        .then((res)=> {            
            this.documents = res.data.data || [];   
            this.pagination = {
              ...this.pagination,
              totalItemCount: res.data.totalItemCount,
              pageCount: res.data.pageCount,
              currentPage: res.data.currentPage,
              count: res.data.count
            };        
          }
        )        
      },
      async onPageChanged(currentPage) {      
        await this.loadDocuments(currentPage);
      },
      async downloadDocumentHandler(peiId){

        const params = {
          peiId: peiId,
          peiAtServiceId: this.peiAtServiceId,
          studentSieId: this.studentSieId
        };

        await reportService.downloadEquipmentUsageGuaranteeDocument(params);          
      }
    }
}

</script>

<style scoped>
.tag-badge-custom {
  width: 365px;

  border-radius: 26px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
}
.document-label {
  font-size: 14px;
  font-weight: 400 !important;
  color: #727272;
}
.document-description {
  font-size: 16px;
  font-weight: 400 !important;
  color: #11291b;
}

.green {
  color: #2db782;
}
</style>

 